import { useMemo } from "react";
import { Col, Row } from "../../../common/components/Layout";
import NullableImage from "../../../common/components/NullableImage";
import ProductDesignation from "../ProductDesignation";
import {
  AliasesParameter,
  CountryOfOriginDescriptorParam,
  GPSDParameter,
  OldDesignationParameter,
  SchaefflerIdParameter,
  TariffParameter,
} from "../../../common/components/Product/ProductParams";
import { MAX_QUANTITY } from "../../../utils/constants";
import { PdpAddToWishlist } from "./common/PdpAddToWishlist";
import { Link } from "../../../common/components/Link";
import { PredefinedTraits } from "../ProductTrait";
import { type PdpPageProductData } from "../../models/PdpPageProductData";
import { userIsPublic, userIsRegistered } from "../../../utils/roles";
import { Card } from "../../../Configurators/Linear/components/Card";
import { Button, Stack, styled, Typography } from "@mui/material";
import { PackagingSelection } from "../../../common/components/PackagingSelection/PackagingSelection";
import CenterContents from "../../../common/components/CenterContents";
import CircleSpinner from "../../../common/components/CircleSpinner/CircleSpinner";
import {
  getCountriesListFromFifteendigit,
  getListPrice,
  getPriceInfo,
  isProductPMA,
} from "../../../feature/ProductDescriptor/v1/productDescriptorUtils";
import { PriceReferenceParam } from "~/feature/cart/cart/components/LineItemEditableParams";
import { useSelector } from "react-redux";
import { QuantityInput } from "../../../common/components/QuantityInput/QuantityInput";
import DistributorPriceTable from "../AddToCartCard/PurchaserAddToCartCard/DistributorPriceTable";
import { ContactSalesTeamLink, getBaseType, PreferredProductsLink } from "./common/PdpLinks";
import { useAddProductToWishlistFlow } from "../../../common/hooks/useAddProductToWishlistFlow";
import { trackPdpWishlistClick } from "../../../feature/Analytics/ga/ga";
import { addToCartApi, bulkAddToCartApi } from "../../../AddToCart/redux/addToCart/actions";
import DisclaimerCountryOrigin from "../../../common/components/Messages/DisclaimerCountryOrigin";
import { canSeePriceRefColumn } from "../../../QuickEntryPopup/helpers";
import { Price, Price as PriceV3, type PriceProps } from "../../../common/components/Price/v3/Price";
import { URL_RECONDITIONABLE } from "../../../utils/url/staticUrls";
import {
  isProductComparisonCheckboxVisible,
  ProductComparisonCheckbox,
} from "../../../ProductComparison/ProductComparisonCheckbox";
import OptimeSolutionsMessage from "../../../common/components/Messages/OptimeSolutionsMessage";
import { isKITKITProduct, isKITProduct, type PackagingInformationEntry } from "../../../models/ProductData";
import { type PriceData } from "../../../models/PriceData";
import { Controller, useFormContext } from "react-hook-form";
import { type AddToCartFormData, type OptionalPartFormData } from "../../../AddToCart/hooks/useAddToCartNew";
import { usePackageRestrictionContext } from "../../../common/components/PackageRestrictionContext/PackageRestrictionContext";
import { AddToCartService } from "../../../AddToCart/AddToCartService";
import { getIsContractAvailable } from "../../redux/productDetailsSelectors";
import { multiply, volatileSum, zero } from "../../../utils/PriceUtils";
import { canSeeListPrice } from "../../../utils/features";
import { HousingMessages } from "../../../common/components/Messages/HousingMessages";
import {
  findMinOrderQuantity,
  getDefaultQuantity,
  usePdpSummaryLogic,
} from "~/ProductDetails/components/ProductSummary/common/usePdpSummaryLogic";
import { useTranslation } from "react-i18next";
import { PhaseInOutLogicProvider, usePhaseInOutLogic } from "~/ProductDetails/components/PhaseInOut/usePhaseInOutLogic";
import { SuccessorNotification } from "~/ProductDetails/components/PhaseInOut/SuccessorNotification/SuccessorNotification";
import { DiscontinuationNotification } from "~/ProductDetails/components/PhaseInOut/DiscontinuationNotification/DiscontinuationNotification";
import { resolveUrl } from "~/utils/url/urlResolver";
import { getTotalStock } from "~/utils/packageEntryUtils";
import classesExtended from "./ExtendedPdpSummary.module.less";
import { AlternativeNotification } from "~/ProductDetails/components/PhaseInOut/AlternativeNotification/AlternativeNotification";
import { PHASE_IN_BUY_ERROR_KEY, PHASE_IN_BUY_WARN_KEY } from "~/ProductDetails/components/PhaseInOut/constants";
import { PreferredProducts } from "~/ProductDetails/components/PhaseInOut/PreferredProducts/PreferredProducts";
import { ProductContext, ProductDescriptorContext } from "~/feature/Product/ProductContext";
import { calculateSalesCampaign4PDP, type PdpSaleData, useSelectPricingDetails } from "~/SalesCampaign/utils";
import { SaleTag } from "~/SalesCampaign/components/SaleTag/SaleTag";
import { SaleDiscountIndicator } from "~/SalesCampaign/components/SaleDiscountIndicator/SaleDiscountIndicator";
import { SaleQuantityIndicator } from "~/SalesCampaign/components/SaleQuantityIndicator/SaleQuantityIndicator";
import { CheckboxWithLabel } from "~/common/components/CheckboxWithLabel";
import { SalesDataProvider } from "~/SalesCampaign/useSalesData";
import { SaleEndIndicator } from "~/SalesCampaign/components/SaleEndIndicator/SaleEndIndicator";
import { InfoProductMessagePMA } from "~/ProductDetails/components/ProductSummary/InfoProductMessagePMA";
import {
  getPurchaseDataFromUrl,
  selectAmountInCart,
} from "~/ProductDetails/components/ProductSummary/PdpSummaryHelper";
import { KitPrices } from "~/ProductDetails/components/ProductSummary/components/KitPrices";
import { Alert } from "~/common/m3/Alert/Alert";
import { InfoOrderHandlingUnitQuantity } from "./InfoOrderHandlingUnitQuantity";
import type { ProductDescriptor } from "~/feature/ProductDescriptor/v1/types";
import { usePurchasePlace, usePurchaseType } from "~/feature/Analytics/ga/recommendations/RecommendationContexts";
import { renderButtons } from "~/ProductDetails/components/ProductSummary/components/Buttons/usePdpButtons";
import { TabId } from "~/ProductDetails/components/usePDPTabs";
import { isMinOrderQuantityRestrictionEnabled, isTariffSurchargeEnabled } from "~/feature/cart/cart/utils/cartUtils";
import RichTooltip from "~/common/components/RichTooltip/RichTooltip";
import Cycle from "~/common/icons/Cycle";
import parse from "html-react-parser";
import { IncludesSurchargeDisclaimer } from "~/common/components/Messages/IncludesSurchargeDisclaimer";
import ProductMMD from "~/feature/Product/elements/ProductMMD";
import MMDAssistant from "../MMDAssistant/MMDAssistant";
import { useDisplayMMDAssistant } from "~/ProductDetails/context/DisplayMMDAssistantContext";
import { FontSize, getFontStyle } from "~/common/components/materialInput/Fonts";
import { PriceElements } from "~/common/components/Price/PriceV4";
import { useSalesHelper } from "~/SalesCampaign/salesHelper";
import Tag from "~/common/components/Tag/Tag";
import { usePdpCmnLogic } from "../MMDAssistant/logic/usePdpCmnLogic";
import {
  AddServiceProductsSection,
  useAddServiceProductsDataState,
} from "../AddServiceProductsSection/AddServiceProductsSection";
import { Product } from "~/feature/Product";
import { transformElements } from "../../../AddToCart/SimpleAddToCart";

interface Props {
  productDescriptor: ProductDescriptor<PdpPageProductData>;
  hasPreferredProducts: boolean;

  preferredProductCodes: string[];
  changeTab: (tabId: string) => void;
}

const isPublic = userIsPublic() || userIsRegistered();

/*
 * Extended product details page summary (starting from breadcrumbs, finishing before tabs).
 * Originally for Distributors only, since SCHAEFF-24168 it's availabile for all Customers (minus Salesmen).
 */
export const ExtendedPdpSummary = ({
  productDescriptor,
  hasPreferredProducts,
  preferredProductCodes,
  changeTab,
}: Props) => {
  const { t } = useTranslation();

  const [selectedProducts, setSelectedProducts] = useAddServiceProductsDataState();

  const reco_place = usePurchasePlace();
  const reco_type = usePurchaseType();
  const displayMMDAssistant = useDisplayMMDAssistant();

  const salesData = useMemo(() => calculateSalesCampaign4PDP({ productDescriptor }), [productDescriptor]);
  const hasSales = salesData.data?.hasSales;

  const formProps = useFormContext<AddToCartFormData>();
  const quantity = formProps.watch("quantity");
  const packCode = formProps.watch("selectedPackCode");
  const priceReference = formProps.watch("priceReference");
  const pack: PackagingInformationEntry | null = formProps.watch("selectedPack");
  const price = formProps.watch("netPrice");

  const saleForPack: PdpSaleData | undefined = salesData.data?.salePerPack[packCode];
  const saleActive = !!saleForPack && formProps.watch("salePriceEnabled");

  const tariffSurcharge = isTariffSurchargeEnabled() && formProps.watch("tariffSurcharge");

  const optionalParts = formProps.watch("optionalParts") as Dict<OptionalPartFormData>;

  const packSize = pack?.packSize ?? 1;

  const qtyInCart = useSelector(selectAmountInCart({ product: productDescriptor, packCode }));
  const {
    flags: { showBetterDeal, isPackageSizeInvalid, MOQHelperLabel, showManufacturerLogo },
  } = usePdpSummaryLogic({
    product: productDescriptor,
    qtyInCart,
    quantity,
    packCode,
    packSize,
    isOnSale: hasSales,
  });

  const phaseInLogic = usePhaseInOutLogic({ product: productDescriptor, preferredProductCodes });

  const restrictionQuery = usePackageRestrictionContext() ?? "";

  const product = productDescriptor.base;

  const isHousingKit = isKITProduct(product);

  const onAddToCartClick = async () => {
    const formValues = formProps.getValues();

    const { recommendationPlace, recommendationType } = getPurchaseDataFromUrl();
    const context = {
      page: reco_place,
      recommendationPlace,
      recommendationType,
    };

    if (isHousingKit) {
      if (selectedProducts.length > 0) {
        // Jan says this case cannot happen.
        throw new Error("Not implemented on purpose");
      }
      AddToCartService.openAddToCartWizard(
        {
          restrictionQuery,
          productCode: product.code,
          initialData: formValues,
          source: "pdp",
        },
        context,
      );
    } else {
      if (selectedProducts.length > 0) {
        const apiItems = await transformElements(selectedProducts);
        bulkAddToCartApi({
          items: [{ ...formValues, productCode: product.code }, ...apiItems],
          restrictionQuery,
          showSuccessDrawer: true,
          context,
        });
      } else {
        addToCartApi({
          productCode: product.code,
          restrictionQuery,
          ...formValues,
          addToCartSource: "pdp",
          context,
        });
      }
    }
  };

  const primaryImage = product.images.filter(
    (imgData) => imgData.imageType === "PRIMARY" && imgData.format === "product",
  )[0];

  const { manufacturerLogoUrl, brandLogoUrl } = product;

  const isContractProduct = getIsContractAvailable(productDescriptor);

  const isSubscription = !productDescriptor.base.quantityVisible;

  const [openAddToWishlist, addToWishlistModal] = useAddProductToWishlistFlow({
    productInput: product,
    selectedOptionalParts: optionalParts,
    initialPriceReference: priceReference,
    initialQuantity: quantity,
  });

  const onWishlistBtnClick = () => {
    trackPdpWishlistClick(productDescriptor.base.designation, 1);
    openAddToWishlist();
  };

  const userCanAddToCart = getCanUserAddToCart(productDescriptor, pack);

  const selectedPackageCode = formProps.watch("selectedPackCode");
  const onSelectPackage = (packCode: string) => formProps.setValue("selectedPackCode", packCode);

  // TODO: Refactor this in 2.7
  const countTotal = (price: PriceData | null, priceUnit: number, qty: number) => {
    return !price ? null : multiply(price, qty / priceUnit);
  };

  const selectedOptionalParts = Object.values(optionalParts).filter((item) => item.selected);

  const optionalPartsPrice = volatileSum(
    ...selectedOptionalParts.map((item) => countTotal(item.netPrice, item.priceUnit, item.quantity) ?? zero()),
  );

  const optionalPartsHaveSurcharge =
    selectedOptionalParts.length > 0 && selectedOptionalParts.some((item) => item.surcharge > 0);
  const hasSurcharge = formProps.watch("surcharge") > 0;

  const totalPrice = countTotal(price, formProps.watch("priceUnit"), quantity);
  const isDistributorPricingTableVisible =
    !isSubscription && !isProductPMA(productDescriptor) && !isKITKITProduct(productDescriptor.base) && !saleActive;

  const isKITKIT = isKITKITProduct(productDescriptor.base);

  const exceedsSalesStock = !!saleForPack && quantity > saleForPack.salesStock;
  const minOrderQuantity = findMinOrderQuantity(productDescriptor, packCode);

  const isMOQCheckEnabled = isMinOrderQuantityRestrictionEnabled() && !hasSales;

  let qtyHelperLabel =
    isMOQCheckEnabled && minOrderQuantity > 1 ? t("page.moq.helperText.moqNotMet", { minOrderQuantity }) : undefined;
  let qtyIsError = false;
  if (isPackageSizeInvalid) {
    qtyHelperLabel = isMOQCheckEnabled ? MOQHelperLabel : t("addToCartPopup.mismatchedQty");
    qtyIsError = isPackageSizeInvalid;
  } else if (phaseInLogic && phaseInLogic.purchaseLogicChange && pack) {
    const totalStockOfPackage = getTotalStock(pack);
    if (quantity > totalStockOfPackage) {
      if (phaseInLogic.purchaseLogicChange && phaseInLogic.purchaseLogicChange.packCodes.includes(pack.packCode)) {
        if (phaseInLogic.purchaseLogicChange.type === "warn") {
          qtyHelperLabel = t(PHASE_IN_BUY_WARN_KEY, { quantity: totalStockOfPackage });
        } else {
          // phaseInLogic.purchaseLogicChange === "error"
          qtyHelperLabel = t(PHASE_IN_BUY_ERROR_KEY, { quantity: totalStockOfPackage });
          qtyIsError = true;
        }
      }
    }
  } else if (saleActive && exceedsSalesStock) {
    qtyHelperLabel = t("feature.salesCampaign.exceedsQty");
  }

  const addToCartDisabled =
    window.SCHA.config.disableAllWS ||
    !userCanAddToCart ||
    isPackageSizeInvalid ||
    qtyIsError ||
    productDescriptor.isLoading ||
    productDescriptor.isError;

  const phaseInBanners = [
    phaseInLogic.successorBanner === "packages" && (
      <SuccessorNotification variant={"basic"} successor={product.successorProduct!} />
    ),
    phaseInLogic.alternativeBanner && <AlternativeNotification data={phaseInLogic.alternativeBanner} />,
  ];

  const hasPhaseInBanner = phaseInBanners.some(Boolean);

  const buttons = renderButtons(productDescriptor, {
    atc: {
      disabled: addToCartDisabled,
      onClick: onAddToCartClick,
      forceChangeToQuote: phaseInLogic.changeATCLabelToQuote,
    },
    wishlist: {
      onClick: onWishlistBtnClick,
    },
    configurator: {
      onClick: () => changeTab(TabId.CONFIGURATOR),
    },
    atcFromSP: {
      quantity,
    },
  });

  const quantityVisible = product.quantityVisible && !product.externalProduct;
  const isExternalProduct = product.externalProduct;

  const mmdCmnData = usePdpCmnLogic();

  const minQtyValue = isMOQCheckEnabled ? getDefaultQuantity(packSize, minOrderQuantity) : packSize;

  return (
    <ProductDescriptorContext value={productDescriptor}>
      <PhaseInOutLogicProvider resultData={phaseInLogic}>
        <SalesDataProvider value={salesData.data}>
          <Row className={"scha__pdp__product-box"}>
            <Col size={3} className={"p-relative"}>
              <Stack gap={2}>
                {phaseInLogic.successorBanner === "image" && (
                  <SuccessorNotification
                    successor={product.successorProduct!}
                    variant={"extended"}
                    discontinued={product}
                  />
                )}

                <Row className={classesExtended.productImage}>
                  {hasSales && <SaleTag className={classesExtended.saleTag} />}
                  <Col size={9}>{primaryImage && <NullableImage data={primaryImage} />}</Col>
                  <Col size={3} className="scha__product-image__logos">
                    {showManufacturerLogo && (
                      <img className={"scha__pdp__manufacturer-logo"} src={manufacturerLogoUrl} />
                    )}
                    {brandLogoUrl && <img className={"scha__pdp__brand-logo"} src={brandLogoUrl} />}
                  </Col>
                </Row>

                {isHousingKit && <HousingMessages.NotFinal />}

                <ProductDesignation
                  as={"h1"}
                  designation={product.designation}
                  size={"headline-medium"}
                  isPreferred={product.preferred}
                  showCopyClipboard
                />

                {product.marketDesignation && <ProductMMD marketDesignation={product.marketDesignation} />}

                <Stack gap={1}>
                  <Product.ShortDescriptionV2
                    component={"h2"}
                    variant="titleMedium"
                    data-test-id={"pdp-short-description"}
                  />
                  <Product.DescriptionV2 component={"h3"} variant="titleSmall" data-test-id={"pdp-long-description"} />
                </Stack>

                {productDescriptor.base.reconditionable && (
                  <RichTooltip
                    content={
                      <Typography>
                        {parse(t("cmsnavigationnode.schaefflerContentCatalog.reconditionableInfo"))}
                      </Typography>
                    }
                    actions={[
                      <Button href={URL_RECONDITIONABLE} variant="text">
                        {t("cmsnavigationnode.schaefflerContentCatalog.moreInfo")}
                      </Button>,
                    ]}
                  >
                    <Tag icon={<Cycle fontSize="small" />} iconPosition="start" variant="success">
                      {t("cmsnavigationnode.schaefflerContentCatalog.reconditionable")}
                    </Tag>
                  </RichTooltip>
                )}

                <Stack gap={2}>
                  <OldDesignationParameter product={product} label={t("productDetailPage.oldDesignation")} />
                  <SchaefflerIdParameter productDescriptor={productDescriptor} />
                  <AliasesParameter product={product} mode={"13-digits"} />
                  <TariffParameter product={product} />
                  {/* <CountryOfOriginParam product={product} /> */}
                  <CountryOfOriginDescriptorParam descriptor={productDescriptor} />

                  {isPublic && (
                    <div className={"mt-60"}>
                      <PdpAddToWishlist product={product} fullWidth={false} selectedOptionalParts={optionalParts} />
                    </div>
                  )}
                </Stack>

                {isPublic && <ContactSalesTeamLink product={product} />}

                <Stack gap={1}>
                  {product.preferred && <PredefinedTraits.PreferredProduct />}
                  {isContractProduct && <PredefinedTraits.ContractProduct />}
                  {/*<PredefinedTraits.BoughtBefore/>*/}
                </Stack>
              </Stack>
            </Col>
            <Col size={9}>
              <Stack gap={2}>
                {displayMMDAssistant && (
                  <MMDAssistant
                    marketDesignation={product.marketDesignation}
                    initialData={{
                      quantity: quantity,
                      priceReference: priceReference,
                      ...mmdCmnData,
                    }}
                  />
                )}
                <Card disableHover={true}>
                  <Row>
                    <Col className={classesExtended.packagingColumn} size={7}>
                      <div className={classesExtended.packagingArea}>
                        {hasPhaseInBanner && <div className={classesExtended.phaseInContent}>{phaseInBanners}</div>}
                        <div className={classesExtended.packagingAreaContent}>
                          {phaseInLogic.discontinuedBanner === "product" && !phaseInLogic.alternativeBanner && (
                            <DiscontinuationNotification
                              className={"scha__pdp__phase-out__successor__package"}
                              variant={"product"}
                              discontinued={product}
                            />
                          )}
                          {isKITKIT && (
                            <Stack gap={2}>
                              <HousingMessages.PackagingDisclaimer />
                              <Alert severity={"info"}>{t("addToCartPopup.disclaimer")}</Alert>
                            </Stack>
                          )}
                          {!isKITKIT && (
                            <>
                              {productDescriptor.isAvailabilityLoading && (
                                <CenterContents className={"mb-30 w-100"}>
                                  <CircleSpinner />
                                </CenterContents>
                              )}

                              <div
                                className={"d-flex flex-justify-between mb-3 flex-align-center"}
                                hidden={!productDescriptor.availability}
                              >
                                <span className={"title-medium"}>{t("addToCartPopup.packagingOption")}</span>
                              </div>

                              {productDescriptor.availability && (
                                <PackagingSelection
                                  selectedCode={selectedPackageCode}
                                  onSelectCode={onSelectPackage}
                                  product={productDescriptor}
                                  initiallyExpanded={true}
                                />
                              )}
                              <div className="scha__pdp__notifications">
                                {isProductPMA(productDescriptor) && <InfoProductMessagePMA />}
                                <DisclaimerCountryOrigin
                                  // disabled={getCountriesList({ product: productDescriptor.base }).length === 0}
                                  disabled={
                                    getCountriesListFromFifteendigit({ descriptor: productDescriptor }).length === 0
                                  }
                                />
                              </div>
                            </>
                          )}
                        </div>

                        {phaseInLogic.preferredProductCodes && (
                          <ProductContext value={product}>
                            <div className={classesExtended.phaseInContentPreferred}>
                              <PreferredProducts data={phaseInLogic.preferredProductCodes} />
                            </div>
                          </ProductContext>
                        )}
                      </div>
                    </Col>
                    <Col size={5}>
                      <Box>
                        {productDescriptor.isLoading && <CircleSpinner className={"mb-30"} />}

                        {saleActive && <SaleEndIndicatorStyled endDate={saleForPack?.endDate} />}

                        <Stack gap={2} hidden={!productDescriptor.isLoaded}>
                          {!isHousingKit && (
                            <SalePriceSection
                              descriptor={productDescriptor}
                              packCode={packCode}
                              quantity={quantity ?? 1}
                              priceReference={priceReference}
                            />
                          )}

                          {isHousingKit && (
                            <KitPrices
                              totalPrice={totalPrice ?? zero()}
                              optionalPartsPrice={optionalPartsPrice}
                              product={product}
                              includesSurcharge={hasSurcharge}
                              optionalPartsIncludesSurcharge={optionalPartsHaveSurcharge}
                            />
                          )}

                          {product.isOptime && <OptimeSolutionsMessage />}

                          <GPSDParameter product={product} />

                          {hasSales && (
                            <Controller
                              name={"salePriceEnabled"}
                              render={({ field: { value, onChange } }) => (
                                <CheckboxWithLabel
                                  checked={value}
                                  onCheck={onChange}
                                  hidden={!saleForPack || !!priceReference}
                                >
                                  {t("feature.salesCampaign.specialDealPrice")}
                                </CheckboxWithLabel>
                              )}
                            />
                          )}

                          {!isExternalProduct && (
                            <PriceReferenceParam
                              data-test-id={"pdp-price-reference"}
                              priceReference={priceReference}
                              externalLabel={true}
                              product={product}
                              editable={canSeePriceRefColumn()}
                              disabled={saleActive}
                              onChange={(value) => formProps.setValue("priceReference", value ?? "")}
                            />
                          )}

                          {quantityVisible && (
                            <QuantityInput
                              data-test-id={"pdp-quantity"}
                              value={quantity}
                              onValueChange={(value) =>
                                formProps.setValue("quantity", value, { shouldTouch: true, shouldDirty: true })
                              }
                              min={minQtyValue}
                              step={packSize}
                              error={qtyIsError}
                              helperLabel={qtyHelperLabel}
                              max={MAX_QUANTITY}
                              variant={"compact"}
                            />
                          )}

                          <InfoOrderHandlingUnitQuantity
                            preferredPackQuantity={pack?.preferredPackQuantity ?? null}
                            packSize={pack?.packSize ?? 1}
                            quantity={quantity}
                          />

                          {showBetterDeal && <Alert severity="info">{t("addProduct.scalingDeal")}</Alert>}

                          {phaseInLogic.showAdditionalSuccessorLink && (
                            <Link href={resolveUrl(product.successorProduct!.url)}>
                              {t("page.pdp.phaseinout.goToSuccessorLink", {
                                designation: product.successorProduct!.designation,
                              })}
                            </Link>
                          )}

                          {isDistributorPricingTableVisible && (
                            <DistributorPriceTable
                              product={productDescriptor}
                              selectedPackageCode={selectedPackageCode}
                              quantity={quantity}
                            />
                          )}

                          {hasPreferredProducts && <PreferredProductsLink baseType={getBaseType(productDescriptor)} />}

                          {isProductComparisonCheckboxVisible(product) && !isExternalProduct && (
                            <ProductComparisonCheckbox
                              productCode={productDescriptor.base.code}
                              gaLocation={"Product Detail Page"}
                            />
                          )}

                          {window.SCHA.feature.buyboxReco && (
                            <AddServiceProductsSection
                              productCode={productDescriptor.base.code}
                              selectedProducts={selectedProducts}
                              onSelectedProductChange={setSelectedProducts}
                            />
                          )}

                          <Stack gap={1}>{buttons}</Stack>

                          <ContactSalesTeamLink
                            className={"scha__pdp__contact-sales-team"}
                            product={productDescriptor.base}
                          />

                          {phaseInLogic.successorBanner === "atc" && (
                            <SuccessorNotification
                              className={"scha__pdp__phase-out__successor__atc"}
                              successor={product.successorProduct!}
                            />
                          )}

                          {!tariffSurcharge && (
                            <IncludesSurchargeDisclaimer hasSurcharge={hasSurcharge} tariffSurcharge={false} />
                          )}
                        </Stack>
                      </Box>
                    </Col>
                  </Row>
                </Card>
              </Stack>
            </Col>
          </Row>
          {addToWishlistModal}
        </SalesDataProvider>
      </PhaseInOutLogicProvider>
    </ProductDescriptorContext>
  );
};

const Box = styled("div")({
  padding: "16px",
  height: "100%",
  position: "relative",
});

export const getCanUserAddToCart = (
  product: ProductDescriptor,
  packaging: PackagingInformationEntry | undefined | null,
) => {
  if (!packaging || !product.isLoaded) {
    return false;
  }

  const packCode = packaging.packCode;
  const priceInfo = getPriceInfo({ product, packCode });
  const availabilityInfo = product.availability;

  const isDataAvailable = (priceInfo?.hasPrice ?? false) && (availabilityInfo?.hasPackaging ?? false);

  return isDataAvailable;
};

const SaleEndIndicatorStyled = styled(SaleEndIndicator.V2)({
  position: "absolute",
  top: 4,
  right: 4,
});

const CurrentPrice = styled(Price, {
  shouldForwardProp: (prop) => prop !== "soldOut",
})<PriceProps & { soldOut?: boolean }>(({ soldOut, theme }) => ({
  ...getFontStyle(FontSize.HeadlineSmall),
  fontWeight: soldOut ? "normal" : "bold",
  color: soldOut ? theme.palette.text.secondary : theme.palette.text.primary,
  textDecoration: soldOut ? "line-through" : "none",
}));

const OldPrice = styled(Price, {
  shouldForwardProp: (prop) => prop !== "soldOut",
})<PriceProps & { soldOut?: boolean }>(({ soldOut, theme }) => ({
  color: soldOut ? theme.palette.text.primary : theme.palette.text.secondary,
  fontWeight: soldOut ? "bold" : "normal",
  textDecoration: soldOut ? "none" : "line-through",
}));

interface SalePriceSectionProps {
  descriptor: ProductDescriptor;
  packCode: string;
  quantity: number;
  priceReference: string;
}

const SalePriceSection = ({ descriptor, packCode, quantity, priceReference }: SalePriceSectionProps) => {
  const { t } = useTranslation();
  const product = descriptor.base;
  const formProps = useFormContext<AddToCartFormData>();
  const tariffSurcharge = isTariffSurchargeEnabled() && formProps?.watch("tariffSurcharge");

  const isOnSale = useSalesHelper(descriptor).isPackageOnSale(packCode);
  const saleActive = isOnSale && (formProps?.watch("salePriceEnabled") ?? false);

  const { data } = useMemo(() => calculateSalesCampaign4PDP({ productDescriptor: descriptor }), [descriptor]);
  const saleForPack = data?.salePerPack?.[packCode];
  const { price, oldPrice, netPrice, discountFormatted } = useSelectPricingDetails({
    packCode,
    quantity,
    priceReference,
    productCode: product.code,
    salesData: saleForPack,
    saleActivated: saleActive,
  });
  const hasSurcharge = (netPrice?.surcharge ?? 0) > 0;

  const showExtraLabels = !saleActive;
  const isSoldOut = saleForPack?.soldOut ?? false;

  const somePriceValid = (price?.value ?? 0) > 0 || (oldPrice?.value ?? 0) > 0;

  const listPrice = getListPrice({ product: descriptor, packCode });
  const showListPrice =
    !saleActive &&
    !!listPrice &&
    canSeeListPrice({
      product: descriptor,
      isSpecialPrice: netPrice?.isSpecial ?? false,
      hasSurcharge,
    });

  return (
    <Stack gap={2}>
      <Stack gap={0}>
        {/* Current price */}
        <Stack direction={"row"} gap={1} alignItems={"center"}>
          <CurrentPrice
            price={price}
            zeroText={t("product.priceOnRequest")}
            tariffSurcharge={tariffSurcharge}
            soldOut={isSoldOut}
            surchargeEnabled={hasSurcharge}
          />

          {saleActive && (
            <SaleDiscountIndicator.V2 discountFormatted={discountFormatted} soldOut={false} variant="titleLarge" />
          )}
        </Stack>
        {/* Old price */}
        {oldPrice && <OldPrice price={oldPrice} soldOut={isSoldOut} />}
        {/* Price Unit */}
        {somePriceValid && (
          <>
            <PriceV3.NetPriceUnit price={netPrice} />
            {tariffSurcharge && <p className="label-small mb-1">{t("price.tariff.surcharge.applicable")}</p>}
            {showExtraLabels && <PriceV3.ExtraLabels price={netPrice} surchargeEnabled={false} />}
          </>
        )}
      </Stack>
      {/* Sale stock */}
      {saleActive && saleForPack && <SaleQuantityIndicator.V2 quantity={saleForPack.salesStock} variant="labelLarge" />}
      {/* List price */}
      {showListPrice && (
        <PriceElements.Stack>
          <PriceElements.Price price={listPrice} variant="titleMedium" fontWeight={"bold"} />
          <PriceElements.ListPriceLabel unit={netPrice?.unit ?? 1} variant="labelLarge" />
        </PriceElements.Stack>
      )}
    </Stack>
  );
};
